import { useDispatch, useSelector } from "react-redux";
import FilterHeader from "../../components/FilterHeader";
import FilterSelection from "../../../../experiments/BubbleJourney/components/FilterSelection";
import { customSortOrder } from "../../../../lib";
import {
  AnalyticsTypeMap,
  headToHeadStatType,
  LOCATION_MAP,
  SelectionDescriptionMap,
  STATS_VIEW,
  StatsDropdownOptionsSortOrder,
} from "../../../../constants";
import styles from "./Stats.module.scss";
import FilterSelectionLoadingSkeleton from "../../../../components/FilterSelectionLoadingSkeleton";
import { useMarketSelections } from "../../../../hooks/useMarketSelections";
import { sendAnalyticsEvent } from "../../../../lib/postMessage";
import FilterHeadToHeadWarning from "../../components/FilterHeadToHeadWarning";
import { FILTERS, SELECT } from "../../../../constants/analytics";

const Stats = () => {
  const dispatch = useDispatch();
  const { ppConfig, prefetchedFilters } = useSelector((state) => state.filter);
  const { stats } = prefetchedFilters;
  const { activeView } = useSelector((state) => state.view);
  const sortedFilterArray = customSortOrder(
    ppConfig.basedOn,
    StatsDropdownOptionsSortOrder
  );

  const { marketSelectionsCount } = useMarketSelections({
    isMultipleSelection: false,
    marketType: "h2h",
  });

  const showH2hWarning =
    !marketSelectionsCount.fetching && marketSelectionsCount.count === 0;

  function handleSortBySelection(stat) {
    dispatch({
      type: "TOGGLE_FILTER_SELECTION",
      payload: {
        filter: STATS_VIEW,
        type: stat.type,
      },
    });
    sendAnalyticsEvent({
      event: FILTERS,
      type: AnalyticsTypeMap.get(STATS_VIEW),
      action: SELECT,
      value: stat.name,
      location: LOCATION_MAP.get(activeView) || "",
    });
    dispatch({
      type: "FINALISE_FILTER_SELECTIONS",
    });
    dispatch({
      type: "SET_ACTIVE_FILTER_VIEW",
      payload: "",
    });
  }

  return (
    <>
      <FilterHeader />
      <div className={styles.statsSelections}>
        {sortedFilterArray.length
          ? sortedFilterArray.map((stat) => (
              <FilterSelection
                key={stat.type}
                onClick={() => handleSortBySelection(stat)}
                checked={stat.type === stats}
                showCheckbox={false}
                disabled={showH2hWarning && stat.type === headToHeadStatType}
                label={stat.name}
              >
                <FilterSelectionLoadingSkeleton
                  skeletonKey={stat.type}
                  textBlocks={2}
                />
                <div className={styles.filterContent}>
                  <h4>{stat.name}</h4>
                  <p>{SelectionDescriptionMap.get(stat.type)}</p>
                  {showH2hWarning && stat.type === headToHeadStatType && (
                    <FilterHeadToHeadWarning />
                  )}
                </div>
              </FilterSelection>
            ))
          : null}
      </div>
    </>
  );
};

export default Stats;
